<template>
    <div>
        <div class="row my-4">
            <button
                @click.prevent="deleteModule"
                type="button"
                class="btn bg-utel-v2-secondary p-2 px-3 rounded-pill text-primary d-inline-block"
                style="width: fit-content"
                alt="Eliminar Módulo"
                title="Eliminar módulo"
            >
                <i class="fa-regular fa-trash-can"></i>
                Eliminar módulo
            </button>
        </div>
        <div class="row mt-4">
            <label class="field-label" for="moduleNameInput">Nombre del módulo</label>
            <input v-model="module.name" type="text" id="moduleNameInput" class="form-control rounded-8 sin-borde" placeholder="Nombre del módulo">
        </div>

        <div class="row mt-4">
            <label class="field-label" for="moduleDescriptionInput">Descripción</label>
            <textarea v-model="module.description" id="moduleDescriptionInput" placeholder="Descripción del módulo" class="form-control sin-borde rounded-8" :rows="5"></textarea>
        </div>

        <div class="row mt-4">
            <span class="field-label" >Lecciones</span>
            <p>Puedes subir más de un archivo para conformar las lecciones a esta sección y organizarlo en el orden que consideres </p>
        </div>

        <div class="row mt-4">
            <draggable v-model="module.lessons" handle=".handle" :animation="200">
                <transition-group>
                    <div class="lesson-container my-3 d-flex" v-for="lesson in module.lessons" :key="lesson.id">
                        <div class="drag-icon px-2 d-flex align-items-center py-3">
                            <i class="fa fa-grip-vertical handle fa-2x"></i>
                        </div>
                        <div class="d-flex lesson-content w-100 p-3 justify-content-between align-items-center bg-utel-v2-secondary">
                            <div>
                                <span class="ms-2">
                                    <strong>
                                        <i class="fa-regular fa-file"></i>
                                        {{  lesson.name  }}
                                    </strong>
                                </span>
                                <br>
                                <small>Contenido: Texto</small>
                            </div>
                            <div class="d-flex">
                                <button
                                    type="button"
                                    class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary"
                                    alt="Editar lección"
                                    title="Editar lección"
                                    @click="editLesson(lesson)"
                                >
                                    <i class="fa-regular fa-pen-to-square"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary"
                                    alt="Eliminar lección"
                                    title="Eliminar lección"
                                    @click="deleteLesson(lesson)"
                                >
                                    <i class="fa-regular fa-trash-can"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </draggable>
        </div>

        <div class="row mt-4 bg-utel-v2-secondary rounded-8 px-2" v-if="activeLesson">
            <create-course-step-2-module-lesson
                :lesson="activeLesson"
                @onSave="saveActiveLesson"
                @onCancel="resetActiveLesson"
            ></create-course-step-2-module-lesson>
        </div>

        <div class="row mt-4">
            <div class="d-flex p-0 mb-3 justify-content-end">
                <button class="btn text-primary sin-borde px-4 rounded-8" @click="addLesson">
                    <i class="fa fa-plus"></i>
                    Agregar lección
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    import draggable from 'vuedraggable'
    export default {
        props: ['module', 'editing', 'eliminaPost','eliminaItemLesson','eliminaSection'],
        components: {
            draggable
        },
        data(){
            return {
                isEditingLesson: false,
                activeLesson: {
                    id: Date.now(),
                    name: '',
                    typeContent: '',
                    durationLength: '',
                    durationType: '',
                    description: null,
                },
                validating: false,
                isEditing: this.editing || false
            }
        },
        beforeUpdate(){
            if (!this.validating) {
                this.validating = true;
                this.validate();
                this.validating = false;
            }
        },
        mounted(){
            if (this.editing) {
                this.activeLesson = null;
            }
        },
        methods: {
            resetActiveLesson(){
                this.activeLesson = null;
            },
            saveActiveLesson(lesson){
                if (this.isEditingLesson) {
                    this.lessons = this.module.lessons.map(innerLesson => {
                        if ( lesson.id === innerLesson.id ) {
                            return lesson;
                        }

                        return innerLesson;
                    })
                }else{
                    this.module.lessons.push(lesson);
                }

                this.activeLesson = null;
                this.isEditingLesson = false;
            },
            editLesson(lesson){
                this.activeLesson = null;
                setTimeout(() => {
                    this.activeLesson = lesson;
                    this.isEditingLesson = true;
                }, 200);
            },
            deleteLesson(lesson){
                if (!!lesson.post_id) {
                    this.eliminaPost?.push(lesson.post_id);
                }
                if (!!lesson.section_item_id) {
                    this.eliminaItemLesson?.push(lesson.section_item_id);
                }
                if (this.activeLesson) {
                    const lessonIsAdded = this.module.lessons.find(lesson => lesson.id !== this.activeLesson.id);
                    if (lessonIsAdded) {
                        this.activeLesson = null;
                    }
                }

                this.module.lessons = this.module.lessons.filter(innerLesson => innerLesson.id !== lesson.id);
                this.isEditingLesson = false;
            },
            addLesson(){
                this.isEditingLesson = false;

                this.activeLesson = {
                    id: Date.now(),
                    name: '',
                    typeContent: '',
                    durationLength: '',
                    durationType: '',
                    file: null,
                    description: null,
                    link: null
                }
            },
            validate(){
                this.module.isValid = true;
                ['name', 'description'].forEach(propertyName => {
                    if (this.module[propertyName].trim().length < 1) {
                        this.module.isValid = false;
                    }
                })
            },
            deleteModule(){
                if (!!this.module.section_id) {
                    this.eliminaSection?.push(this.module.section_id)
                }

                if (!!this.module.lessons) {
                    for (const  lesson of this.module.lessons) {
                        this.deleteLesson(lesson);
                    }
                }
                this.$emit('onDelete', this.module);
            }
        }
    }
</script>
<style>
    .field-label{
        color: #494949;
        font-size: 16px;
        font-weight: 600;
    }

    .drag-icon{
        background-color: #E0E2FF4D;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        cursor: move;
    }

    .lesson-content{
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }
</style>
